var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-alert',{staticClass:"position-fixed fixed-top m-0 rounded-0",attrs:{"id":"checkoutAlert","variant":"info","dismissible":""},model:{value:(_vm.showAlert),callback:function ($$v) {_vm.showAlert=$$v},expression:"showAlert"}},[_vm._v(" Now that you're signed in, you can manage your plan below! ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }